<script setup lang="ts">
import { ref } from 'vue'
import { cmsApiService, type CmsTermsAndConditions } from '@nsftx/seven-client-retail-vue-sgp'
import { NXGDSLoadingState } from '@nsftx/seven-nxg-design-system'
import STEmptyState from '@/ui/components/STEmptyState.vue'
import STStaticContent from '@/ui/components/STStaticContent.vue'
import { logService } from '@nsftx/seven-client-retail-utils'
import errorParser from '@/utils/errorParser'

const content = ref<CmsTermsAndConditions | undefined>()
const isLoading = ref(true)
const LOG_PREFIX = '[TermsAndConditionsView]'

cmsApiService
  .getTermsAndConditions('ssbt', 'en')
  .then((response) => {
    content.value = response.data.termsAndConditions.docs
  })
  .catch((error) => {
    logService.warn(`${LOG_PREFIX} get request has failed. T&C could not be fetched.`, {
      details: error,
      ...errorParser.parseUpstream(error),
      code: 'ST_TERMS_AND_CONDITIONS_API_ERROR'
    })
  })
  .finally(() => {
    isLoading.value = false
  })
</script>

<template>
  <div class="st-terms-and-conditions st-h-100">
    <NXGDSLoadingState
      v-if="isLoading"
      :title="$t('common_loading')"
      :subtitle="$t('common_please_wait')"
      class="st-w-100"
    />
    <div v-else class="st-terms-and-conditions-container">
      <div class="st-terms-and-conditions-wrapper">
        <STStaticContent
          v-if="content"
          :content="content.mainSection"
          :summary="content.summarySection"
          :title="$t('pages_terms_and_conditions_title')"
        />

        <STEmptyState
          v-else
          icon="void"
          :text="$t('terms_and_conditions_no_content', { lang: 'English' })"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.st-terms-and-conditions {
  display: flex;
  flex-direction: column;
  padding: var(--nxgds-alias-spacing-lg);
  align-items: flex-start;
  gap: var(--nxgds-alias-spacing-lg);

  &-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    align-items: center;
    align-self: stretch;
    background: var(--nxgds-mapped-color-surface-component-card-default);
    border-radius: var(--nxgds-alias-radius-corner-theme);
    gap: var(--nxgds-alias-spacing-5xl);
  }

  &-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: var(--nxgds-alias-spacing-3xl);
    flex: 1;
    min-height: 0;
  }
}
</style>
